import { render, staticRenderFns } from "./ProductAdditionalInfo.vue?vue&type=template&id=ffb6e7be&scoped=true"
import script from "./ProductAdditionalInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductAdditionalInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductAdditionalInfo.vue?vue&type=style&index=0&id=ffb6e7be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb6e7be",
  null
  
)

export default component.exports